import { Component, OnInit, ViewChild } from '@angular/core';
import { DocServices } from 'src/app/services/docs/docs.services';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { Subject } from 'rxjs';
import { SidebarService } from 'src/app/services/sideBare.service';
import { sharePitSevices } from 'src/app/services/pitupload/sharePit.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePicker, DatePickerModule } from 'primeng/datepicker';
import { OpePit } from 'src/app/models/OpePit';
import { DocPit } from 'src/domain/docPit';
import { PituploadService } from 'src/app/services/pitupload/pitupload.service';
import { DocPitBlob } from 'src/domain/docPitBlob';
import { CommonModule, DatePipe } from '@angular/common';
import { DocVtPit } from 'src/domain/docVtPit';
import { PrimeNG } from 'primeng/config';
import { ProgressBarModule } from 'primeng/progressbar';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';



@Component({
  selector: 'app-pitupload-doc-list',
  templateUrl: './pitupload-doc-list.component.html',
  styleUrls: ['./pitupload-doc-list.component.scss'],
  imports: [ProgressBarModule,FormsModule,ButtonModule,CommonModule,TableModule,ToastModule,ConfirmDialogModule,DialogModule,DatePickerModule,TextareaModule],
  providers: [DatePipe, ConfirmationService, MessageService]
})
export class PituploadDocListComponent implements OnInit {


  @ViewChild('calendar') calendar!: DatePicker;

  fr = {
    firstDayOfWeek: 1,
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jui', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
    today: 'Aujourd\'hui',
    clear: 'Vider',
    dateFormat: 'dd/mm/yy',
    weekHeader: 'Semaine'
  };

  dateDoc = new Date();
  docs: DocPit[] = [];

  programmeseled!: OpePit;
  docsDto!: any;
  afficheerrorDoc: boolean = false;
  urltoDowloand!: any;
  container!: boolean;
  private _destroy$: Subject<void> = new Subject();
  addDocDialog = false;
  titlepopupAddDoc = "";
  nameDoc = "";
  commentDoc = "";
  cfr: any;
  previewUrl: string | ArrayBuffer | null = null;
  fileUploader!: File | null;
  selectedDocPitToSubmit: DocVtPit | null = null;
  selectedDocdate!: Date;
  iconeDocFile!: string;
  Math = Math;

  error!: string;
  constructor(public datePipe: DatePipe, public pitService: PituploadService, public sharePitSevices: sharePitSevices, public _sidebar: SidebarService, public share: shareOpeSevices, private servicedoc: DocServices,
    private confirmationService: ConfirmationService, private messageService: MessageService, private primengConfig: PrimeNG
  ) {
    this.primengConfig.setTranslation(this.fr);
  }

  ngOnInit() {
    this.programmeseled = this.sharePitSevices.pituploadSelectedOpe;
    if (this.programmeseled) {
      this.getAllDocs();
    }
  }

  getAllDocs() {
    this.share.showprogressbar = true;
    this.pitService.getDocumentsBynumOpe(this.programmeseled.numOpe).subscribe((data: any) => {
      this.docs = data;
      let pos = 0;
      this.docs.forEach((element: any) => {
        element.position = pos;
        pos = pos + 1;
      }
      );
      this.share.showprogressbar = false;
      this.addDocDialog = false;
    },
      error => {
        this.share.showprogressbar = false;
        //console.log(error);
      })
  }


  addDocument() {
    this.selectedDocPitToSubmit = null;
    this.titlepopupAddDoc = "Ajouter un document";
    this.fileUploader = null;
    this.nameDoc = "";
    this.commentDoc = "";
    this.dateDoc = new Date;
    this.selectedDocdate = new Date;
    this.addDocDialog = true;
    this.initDocToSubmit();
  }

  initDocToSubmit() {
    this.selectedDocPitToSubmit = {
      code: null,
      eiBinDocPitDto: null,
      numOpe: this.programmeseled.numOpe,
      langue: "FR",
      urlDoc: "",
      urlImage: "",
      commentaire: "",
      typeDoc: 0,
      position: 0,
      dc: this.datePipe.transform(new Date, 'yyyy-MM-ddThh:mm:ssZ')?.toString(),
      dm: this.datePipe.transform(new Date, 'yyyy-MM-ddThh:mm:ssZ')?.toString(),
      user: this.sharePitSevices.user,
      nomDoc: ""
    }
  }

  editDoc(doc: DocVtPit) {
    this.selectedDocPitToSubmit = doc;
    this.titlepopupAddDoc = "Modifier un document";
    this.fileUploader = null;
    this.nameDoc = this.selectedDocPitToSubmit.nomDoc;
    this.commentDoc = this.selectedDocPitToSubmit.commentaire;
    this.dateDoc = new Date(this.selectedDocPitToSubmit.dm ? this.selectedDocPitToSubmit.dm : "");
    this.selectedDocdate = this.dateDoc;
    this.addDocDialog = true;
  }

  downDocAction(doc: DocPit) {
    this.docs = this.change(this.docs, doc.position, doc.position + 1)
    let index = 0;
    this.docs.forEach((element: any) => {
      element.position = index;
      index += 1;
    })
  }
  upDocAction(doc: DocPit) {
    this.docs = this.change(this.docs, doc.position, doc.position - 1)
    let index = 0;
    this.docs.forEach((element: any) => {
      element.position = index;
      index += 1;
    })
  }


  change(old_array: DocPit[], old_index: any, new_index: any) {
    return old_array.map((item, index, array) => {
      if (index === old_index) return array[new_index];
      else if (index === new_index) return array[old_index];
      else return item;
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.fileUploader = file;
    // console.log(file);
    this.iconeDocFile = this.getIconFile(file.name);
    this.handleFile(file);
  }


  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      this.iconeDocFile = this.getIconFile(file.name)
      this.handleFile(file);
    }
  }

  handleFile(file: File) {
    if (file && (file.type.startsWith('image/') ||
      file.type.startsWith('text/plain') ||
      file.type.startsWith('application/vnd.openxmlformats-officedocument.wordprocessingml.document') ||
      file.type.startsWith('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
      file.type.startsWith('application/vnd.openxmlformats-officedocument.presentationml.presentation') ||
      file.type.startsWith('application/x-zip-compressed') ||
      file.type.startsWith('application/pdf')
    )) {
      this.fileUploader = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewUrl = reader.result;
      }
      reader.readAsDataURL(file);

    } else {
      this.messageService.add({ severity: 'error', summary: "Le fichier n'est pas accepté ", detail: file.type });
    }
  }

  annulerAddDoc() {
    this.dateDoc = new Date();
    this.nameDoc = "";
    this.commentDoc = "";
    this.addDocDialog = false;
  }
  luanchAddDoc() {

    let blobString = (this.previewUrl as string).substr((this.previewUrl as string).lastIndexOf(',') + 1)
    let docPitBob: DocPitBlob = {
      bcode: null,
      bnom: this.fileUploader?.name,
      btype: "",
      bblob: blobString,
      btaille: this.fileUploader?.size
    }
    if (this.fileUploader != null && this.selectedDocPitToSubmit) {
      this.selectedDocPitToSubmit.eiBinDocPitDto = docPitBob;
      this.selectedDocPitToSubmit.eiBinDocPitDto.bcode = this.selectedDocPitToSubmit.code;
      this.selectedDocPitToSubmit.eiBinDocPitDto.btype = this.fileUploader.name.substring(this.fileUploader.name.lastIndexOf('.') + 1);
      this.selectedDocPitToSubmit.nomDoc = this.fileUploader.name.substring(0, this.fileUploader.name.lastIndexOf('.'));
      this.selectedDocPitToSubmit.urlDoc = this.fileUploader.name;
      this.selectedDocPitToSubmit.urlImage = this.fileUploader.name;
    }
    if (this.selectedDocPitToSubmit) {
      this.selectedDocPitToSubmit.commentaire = this.commentDoc;
      this.selectedDocPitToSubmit.dm = this.datePipe.transform(this.dateDoc, 'yyyy-MM-ddThh:mm:ssZ')?.toString();
      this.share.showprogressbar = true;
      this.pitService.updateDocPit(this.selectedDocPitToSubmit).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: "Modification", detail: "Le document " + this.nameDoc + " est modifié avec succès" });
          this.share.showprogressbar = false;
          this.getAllDocs();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
          this.share.showprogressbar = false;
        }
      });
    }
  }
  deleteDocument(doc: DocVtPit) {
    this.share.showprogressbar = true;
    this.pitService.deleteDocVit(doc).subscribe(
      {
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: "Suppression", detail: "Le document " + doc.nomDoc + " est supprimé avec succès" });
          this.share.showprogressbar = false;
          this.getAllDocs();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
          this.share.showprogressbar = false;
        }
      })
  }

  confirm2(doc: any) {
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Valider la suppression ?',
      acceptLabel: 'Oui',
      accept: () => {
        //this.messageService.add({ severity: 'success', summary : "Suppression", detail: "Le document est supprimé avec succès" });
        this.deleteDocument(doc);
      },
      rejectLabel: 'Non'
    });
  }

  deletelocalMedia() {
    this.fileUploader = null;
  }

  getIconFile(filename: string): string {
    let ext = filename.substr(filename.lastIndexOf('.') + 1);
    if (ext.toUpperCase() === 'PDF') { return 'assets/images/icons/icon-pdf.svg' };
    if (ext.toUpperCase() === '7Z', ext.toUpperCase() === 'ZIP') { return 'assets/images/icons/icon-zip.svg' };
    if (ext.toUpperCase() === 'JPG' || ext.toUpperCase() === 'PNG' || ext.toUpperCase() === 'JPEG') { return 'assets/images/icons/icon-document-invert.svg' };
    if (ext.toUpperCase() === 'DOCX' || ext.toUpperCase() === 'DOC') { return 'assets/images/icons/icon-doc.svg' };
    if (ext.toUpperCase() === 'TXT' || ext.toUpperCase() === 'XLSX' || ext.toUpperCase() === 'PPTX') { return 'assets/images/icons/icon-doc.svg' };
    return 'assets/images/icons/icon-zip.svg';
  }
}
